import { addDays, isAfter } from 'date-fns';
import * as React from 'react';
import { Form, Row } from 'react-bootstrap';
import DatePicker from 'react-datepicker';

import { FormContext } from '@/helper/context';

import { CustomInput } from './datepicker-custom';

interface Properties {
  index?: number;
  value?: Times;
  showLabel?: boolean;
  noChangeTracker?: boolean;
}
interface Times {
  startDate: string;
  endDate: string;
}

export function SelectorDateRange({ index, value, showLabel = true, noChangeTracker = false }: Properties) {
  const { changeTracker, setWasChanged, disabled, errors } = React.useContext(FormContext);

  const yesterday = addDays(new Date().setHours(0, 0, 0, 0), -1);
  const [endDate, setEndDate] = React.useState(value?.endDate ? new Date(value?.endDate) : yesterday);
  const [startDate, setStartDate] = React.useState(
    value?.startDate ? new Date(value?.startDate) : addDays(yesterday, -14)
  );
  const maxDate = yesterday;

  function setStart(date: Date) {
    if (date) {
      setStartDate(date);
      if (isAfter(date, endDate)) setEndDate(addDays(date, 1));

      if (!noChangeTracker) {
        const didChange = date?.toISOString() == value?.startDate ? false : true;
        changeTracker.current = {
          ...changeTracker.current,
          startTime: didChange
        };
        setWasChanged(Object.values(changeTracker.current).includes(true));
      }
    }
  }

  function setEnd(date: Date) {
    if (date) {
      setEndDate(date);
      if (isAfter(startDate, date)) setStartDate(addDays(date, -1));

      if (!noChangeTracker) {
        const didChange = date?.toISOString() == value?.endDate ? false : true;
        changeTracker.current = {
          ...changeTracker.current,
          endTime: didChange
        };
        setWasChanged(Object.values(changeTracker.current).includes(true));
      }
    }
  }

  return (
    <React.Fragment>
      <Row className='justify-content-center'>
        <Form.Control
          type='hidden'
          name={(index >= 0 ? index + '_' : '') + 'startDate'}
          value={startDate?.toISOString()}
        />
        <Form.Control type='hidden' name={(index >= 0 ? index + '_' : '') + 'endDate'} value={endDate?.toISOString()} />
        <Form.Group className='col-12 mt-3'>
          {showLabel && (
            <span className={'d-block form-label' + (errors?.startTime ? ' is-invalid' : '')}>Date Range</span>
          )}
          <div className='d-flex align-items-center flex-nowrap'>
            <DatePicker
              selected={startDate}
              disabled={disabled}
              onChange={(date) => setStart(date)}
              maxDate={maxDate}
              dateFormat='MMM do'
              customInput={<CustomInput id='startTimeSelector' disabled={disabled} />}
            />
            <span className='mx-2'>-</span>
            <DatePicker
              selected={endDate}
              disabled={disabled}
              onChange={(date) => setEnd(date)}
              minDate={startDate}
              maxDate={maxDate}
              dateFormat='MMM do'
              customInput={<CustomInput id='endTimeSelector' disabled={disabled} />}
            />
          </div>
          <Form.Control.Feedback type='invalid'>
            {errors.startTime}
            {errors.endTime}
          </Form.Control.Feedback>
        </Form.Group>
      </Row>
    </React.Fragment>
  );
}
